export default __webpack_public_path__ + "static/media/img4.f429f389.PNG";